import { useInsuredFiles } from "../../hooks";
import { TagTreeNode } from "./tag-tree-node";

/** The folder tree, shown in the header's folders dropdown. */
export const FilesFolders = () => {
  const { tagTree } = useInsuredFiles();
  return (
    <div className="px-4 py-2">
      {tagTree.length === 0 && <div className="py-1.5 text-muted-foreground text-xs">No folders yet</div>}
      {tagTree.map((tag) => (
        <TagTreeNode key={tag.data.label} tag={tag} depth={0} />
      ))}
    </div>
  );
};
